﻿'use strict'

import $ from 'jquery';
import * as Backbone from 'backbone';
import * as Marionette from 'backbone.marionette';
import * as _ from 'underscore';
import * as Bootstrap from 'bootstrap';

import tpl_dialogPreviewWebpageZoom from './tpl/dialogPreviewWebpageZoom.html';

export default Marionette.ItemView.extend({
    dialogRegion : '#dialogPreviewWebpageZoom_modal',
    getTemplate: function () {
        return tpl_dialogPreviewWebpageZoom({ model: this.model.toJSON() });
    },
    events: {
        "click #dialogPreviewWebpageZoom_btnOk": "onOK"
    },
    onAttach() {
        //$('#app-container').css('zoom', '0.6');
        $('#app-container').css('zoom', '1.0');
    },
    onOK: function () {
        this.triggerMethod('dialog:okclicked', "msg");
        this.trigger("dialog:close");
    }
});